import { Card } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { _floatConverter } from './utility';

function TableComponent({ rows, xBar, count }) {
  let totals = [0, 0, 0, 0];
  let rowsComponent = rows.map((x1Row, index) => {
    let x1Skew = _floatConverter(
      _floatConverter(x1Row) - _floatConverter(xBar)
    );
    let x1SkewSq = _floatConverter(Math.pow(x1Skew, 2));
    let x1SkewCube = _floatConverter(Math.pow(x1Skew, 3));

    totals[0] = _floatConverter(totals[0] + _floatConverter(x1Row));
    totals[1] = _floatConverter(totals[1] + x1Skew);
    totals[2] = _floatConverter(totals[2] + x1SkewSq);
    totals[3] = _floatConverter(totals[3] + x1SkewCube);

    return (
      <tr key={index}>
        <td>{x1Row}</td>
        <td>{x1Skew}</td>
        <td>{x1SkewSq}</td>
        <td>{x1SkewCube}</td>
      </tr>
    );
  });

  totals[0] = parseInt(Math.ceil(totals[0] / xBar));

  let m2 = _floatConverter(totals[2] / 24);
  let m3 = _floatConverter(totals[3] / 24);
  let sk = _floatConverter(Math.pow(m3, 2) / Math.pow(m2, 3));

  return (
    <div>
      <Table striped bordered hover size="sm" className="text-center">
        <thead>
          <tr>
            <th>X</th>
            <th>[ X - x̄ ]</th>
            <th>
              [ X - x̄ ]<sup>2</sup>
            </th>
            <th>
              [ X - x̄ ]<sup>3</sup>
            </th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            {totals.map((total, index) => {
              return <th key={index}> {total} </th>;
            })}
          </tr>
        </tfoot>
        <tbody>{rowsComponent}</tbody>
      </Table>
      <Card>
        <Card.Body>
          <Card.Title>Formulas</Card.Title>
          <Card.Text>
            <b>Sk = </b> (m<sub>3</sub>)<sup>2</sup> / (m<sub>2</sub>)
            <sup>3</sup>
          </Card.Text>
          <Card.Text>
            <b>
              m<sub>2</sub> =
            </b>{' '}
            ∑[ X - x̄ ]<sup>2</sup> / n
          </Card.Text>
          <Card.Text>
            <b>
              m<sub>3</sub> =
            </b>{' '}
            ∑[ X - x̄ ]<sup>3</sup> / n
          </Card.Text>
          <Card.Text>
            <b>n =</b> Count of Items
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Card.Title>Solution</Card.Title>
          <Card.Text>
            <b>n =</b> {count}
          </Card.Text>
          <Card.Text>
            <b>
              ∑[ X - x̄ ]<sup>2</sup> ={' '}
            </b>{' '}
            {totals[2]}
          </Card.Text>
          <Card.Text>
            <b>
              ∑[ X - x̄ ]<sup>3</sup> ={' '}
            </b>{' '}
            {totals[3]}
          </Card.Text>
          <Card.Text>
            <b>
              m<sub>2</sub> =
            </b>{' '}
            {totals[2]} / 24 = <span className="text-primary"> {m2} </span>
          </Card.Text>
          <Card.Text>
            <b>
              m<sub>3</sub> =
            </b>{' '}
            {totals[3]} / 24 = <span className="text-primary"> {m3} </span>
          </Card.Text>
          <Card.Text>
            <b>Sk =</b> ({m3})<sup>2</sup> / ({m2})<sup>3</sup> ={' '}
            <span className="text-primary"> {sk} </span>
          </Card.Text>
        </Card.Footer>
      </Card>
    </div>
  );
}

export default TableComponent;
